// Tab functionality
const tab_item = document.querySelectorAll(".media_tabWrap .sec_tab__main .tab__hdngs .tab__hdng");
const tab_item_content = document.querySelectorAll('.media_tabWrap .sec_tab__main .tab__cntnts .tab__cntnt');

tab_item.forEach((item, index) => {
  item.addEventListener("click", function(){
    console.log("clicked");
    document.querySelector(".tab__hdngs .tab__hdng.active")?.classList.remove("active");
    document.querySelector(".tab__cntnts .tab__cntnt.active")?.classList.remove("active");
    item.classList.add("active");
    tab_item_content[index].classList.add("active");
  });
});

tab_item[0].classList.add("active");
tab_item_content[0].classList.add("active");
// Tab functionality


// Media play/pause function
  // Video Play/Pause
  const videoWrp = document.querySelectorAll(".tab__cntnt__inner .videoWrp");
  
  videoWrp.forEach((videoOuter) => {
    const video_control = videoOuter.querySelector(".play_video");
    const video = videoOuter.querySelector(".popContainer .cust_video");
    const popContainer = videoOuter.querySelector(".popContainer");
    const popOverlay = videoOuter.querySelector(".popOverlay");
    const pop_closeBtn = videoOuter.querySelector(".popContainer .closeBtn");
    const pop_body = document.querySelector(".template-page-media");
    
    video_control.addEventListener("click", function(){
      if(video){
        popOverlay.classList.add("active");
        popContainer.classList.add("active");
        pop_body.classList.add("noScroll");
        video.style.display = "block";
        video.play();
      }
    });
      
    video.addEventListener("ended", function(){
      popOverlay.classList.remove("active");
      popContainer.classList.remove("active");
      pop_body.classList.remove("noScroll");
    });

    popOverlay.addEventListener("click", function(){
      this.classList.remove("active");
      popContainer.classList.remove("active");
      pop_body.classList.remove("noScroll");
      video.pause();
      video.currentTime = 0;
    })
    
    pop_closeBtn.addEventListener("click", function(){
      popOverlay.classList.remove("active");
      popContainer.classList.remove("active");
      pop_body.classList.remove("noScroll");
      video.pause();
      video.currentTime = 0;
    })
  });
  // Video Play/Pause

  // Audio Play/Pause
  const audioWrp = document.querySelectorAll(".tab__cntnt__inner .audioWrp");

  audioWrp.forEach((audioOuter) => {
    const audio_control = audioOuter.querySelector(".play_audio");
    const audio = audioOuter.querySelector(".cust_audio");

    audio_control.addEventListener("click", function(){
      const other_div = document.querySelectorAll(".audioWrp");
      other_div.forEach((div) => {
        div.querySelector(".cust_audio").pause();
        div.querySelector(".cust_audio").currentTime = 0;
        div.querySelector(".cust_audio").style.display = "none";
        div.querySelector(".play_audio").style.display = "block";
      });
      this.style.display = "none";
      audio.style.display = "block";
      audio.play();
    });

    audio.addEventListener("ended", function(){
      let parentDiv = this.closest(".audioWrp");
      let audio_btn = parentDiv.querySelector(".play_audio");
      this.style.display = "none";
      audio_btn.style.display = "block";
      
    });
  });
  // Audio Play/Pause
// Media play/pause function